const insuranceType = [
    "Select from the following...",
    "Medicaid",
    "Medicare with Parts A and B (or a Medicare Advantage plan)",
    "Qualified Health Insurance",
    "None of the Above",
]

export default insuranceType